import _ from 'lodash-es';
import localesPageMap, { i18nPageList } from '~/locales/config';
import navigatorBarI18N from '~/frontend-shared/components/NavigatorBar/i18n';
import KycVerifyFlowI18N from '~/frontend-shared/components/Verify/i18n';
import CustomerServiceI18N from '~/frontend-shared/components/CustomerService/i18n';
import { useIndexStore } from '~~/store';
import { CONFIG_LOCALES_SET, DEFAULT_I18N_LOCALE, DEFAULT_LOCALE, getRedirectPath, LOCALE_MAP, REVERSE_LOCALE_MAP } from '~/frontend-shared/helper/const';
import { createI18n, I18n } from 'vue-i18n';
import { axiosClient } from '~/common/js/axios';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const indexStore = useIndexStore();
  const nuxtApp = useNuxtApp();
  const golang = useCookie('golang');

  const { locale: stateLocale } = indexStore;
  let locale: string;
  let storeLocale;
  if (process.server) {
    // 服务端逻辑 vue-i18n-server 后执行
    locale = (to.params?.lang) as string || (golang.value) as string;
    if (LOCALE_MAP.has(locale)) {
      storeLocale = LOCALE_MAP.get(locale);
    } else if (REVERSE_LOCALE_MAP.has(locale) || CONFIG_LOCALES_SET.has(locale)) {
      storeLocale = locale;
    } else {
      storeLocale = DEFAULT_I18N_LOCALE;
    }
  } else {
    if (!indexStore.localeConfigList || indexStore.localeConfigList?.length === 0) {
      const resData = await axiosClient({
        url: '/gw-api/translation/locale/getConfigLocaleList',
        method: 'GET',
      }) as any;
      if (resData?.success) {
        // @ts-ignore ts检查错误
        indexStore.syncLocaleStore(resData?.data);
      }
    }

    // 客户端逻辑，浏览器跳转时触发
    const localeFromParams:string = (to.params.lang) as string || useCookie('golang')?.value || DEFAULT_I18N_LOCALE;
    let needRedirect;
    let redirectLocale;
    let replace = false;
    // 1. 判断 url 是否携带有效语言参数
    if (!CONFIG_LOCALES_SET.has(localeFromParams)) {
      // 语言参数无效，两种可能
      if (REVERSE_LOCALE_MAP.has(localeFromParams)) {
        // 可能1：老版本参数
        redirectLocale = REVERSE_LOCALE_MAP.get(localeFromParams);
        replace = true;
      } else {
        // 可能2：无效参数，退而求其次从 store 取
        redirectLocale = REVERSE_LOCALE_MAP.has(stateLocale)
          ? REVERSE_LOCALE_MAP.get(stateLocale)
          : stateLocale;
        replace = false;
      }
      needRedirect = true;
    } else {
      // 2. 需要校验语言是否下线
      redirectLocale = REVERSE_LOCALE_MAP.has(localeFromParams) ? REVERSE_LOCALE_MAP.get(localeFromParams) : localeFromParams;
      // @ts-ignore redirectLocale类型any
      if (!redirectLocale || (!indexStore.onlineLocaleConfigMap[redirectLocale] || indexStore.offlineLocaleConfigMap[redirectLocale])) {
        // 当前重定向语言已经下线，需要修正到默认语言
        redirectLocale = DEFAULT_LOCALE;
        needRedirect = true;
        replace = true;
      }
    }
    // TODO: redirectLocale 有undefined可能性
    // if(!redirectLocale){
    //   redirectLocale = DEFAULT_LOCALE;
    // }
    if (needRedirect) {
      const redirectUrl = getRedirectPath(to.fullPath, localeFromParams, redirectLocale, replace);
      if (redirectUrl !== to.fullPath) {
        return navigateTo(redirectUrl);
      }
    }
    storeLocale = LOCALE_MAP.has(redirectLocale) ? LOCALE_MAP.get(redirectLocale) : redirectLocale;
  }

  if (process.client) {
    // 查看当前page和当前locales有没有对应语言包
    const pageName = to.name?.replace('-lang', '');
    // console.log('pageName >>>>>', pageName);
    let localStorageKey = pageName;
    if (localesPageMap.get(pageName)) {
      localStorageKey = localesPageMap.get(pageName);
    }
    let pageLocaleMessages = {};
    let pageDefaultMessages = {};

    if (i18nPageList.has(localStorageKey)) {
      if (storeLocale !== DEFAULT_I18N_LOCALE) {
        try {
          pageDefaultMessages = await import(`~/pages/${localStorageKey}/i18n/${DEFAULT_I18N_LOCALE}.json`);
        } catch (error) {
          console.log(`${pageName}页面${DEFAULT_I18N_LOCALE}语言包缺失`);
        }
      }
      try {
        pageLocaleMessages = await import(`~/pages/${localStorageKey}/i18n/${storeLocale}.json`);
      } catch (error) {
        console.log(`${pageName}页面${storeLocale}语言包缺失`);
      }
    }

    let commonMessages = {};
    try {
      commonMessages = await import(`~/locales/${storeLocale}.json`);
    } catch (error) {
      console.log(`${storeLocale}公共语言包缺失`);
    }


    const registeredI18N = nuxtApp.i18n as I18n;
    let i18n: I18n;
    if (!registeredI18N) {
      i18n = createI18n({
        legacy: false,
        globalInjection: true,
        locale: storeLocale,
        messages: {},
        fallbackLocale: DEFAULT_I18N_LOCALE,
        missingWarn: false,
        fallbackWarn: false,
      });
      nuxtApp.i18n = i18n;
      nuxtApp.vueApp.use(i18n);

      // i18n.global.missingWarn = false;
      // i18n.global.fallbackWarn = false;
    } else {
      i18n = registeredI18N;
    }
    
    (nuxtApp.i18n as I18n).path = (link: string) => {
      if (nuxtApp.i18n.locale === nuxtApp.i18n.fallbackLocale) {
        return `/${link}`;
      }
      if(!nuxtApp?.i18n?.locale){
        return `/${link}`;
      }
      return `/${link}/${nuxtApp.i18n.locale}`;
    };
    if(storeLocale){

    
    (nuxtApp.i18n as I18n).global.mergeLocaleMessage(
      storeLocale,
      _.merge(
        {},
        commonMessages?.default || {},
        { [localStorageKey]: pageLocaleMessages?.default || {} },
        // bmuiMessages[storeLocale],
        navigatorBarI18N[storeLocale],
        KycVerifyFlowI18N[storeLocale],
        CustomerServiceI18N[storeLocale]
      )
    );
    }
    // 如果当前语言和默认语言不一致，就把默认语言的语言包也加载进来
    if (storeLocale !== DEFAULT_I18N_LOCALE) {
      nuxtApp.i18n.global.mergeLocaleMessage(
        DEFAULT_I18N_LOCALE,
        _.merge(
          {},
          commonMessages?.default || {},
          { [localStorageKey]: pageDefaultMessages?.default || {} },
          // bmuiMessages[DEFAULT_I18N_LOCALE],
          navigatorBarI18N[DEFAULT_I18N_LOCALE],
          KycVerifyFlowI18N[DEFAULT_I18N_LOCALE],
          CustomerServiceI18N[DEFAULT_I18N_LOCALE]
        )
      );
    }
  }

  indexStore.CHANGE_LANG(storeLocale);
  // indexStore.locale=storeLocale;
  //nuxtApp.i18n.global.locale.value = storeLocale;

  const isLegacy = (nuxtApp.i18n as I18n).mode === 'legacy';
  const currentLocale = isLegacy ? (nuxtApp.i18n as I18n).global.locale : (nuxtApp.i18n as I18n).global.locale.value;

  if (currentLocale !== storeLocale) {
    if (isLegacy) {
      // @ts-ignore
      console.log('[i18n-mw]UPDATE I18N LOCALE in legacy', nuxtApp.i18n.global.locale);
      // @ts-ignore
      nuxtApp.i18n.global.locale = storeLocale as any;
    } else {
      // @ts-ignore
      console.log('[i18n-mw]UPDATE I18N LOCALE in ref', nuxtApp.i18n.global.locale);
      // @ts-ignore
      nuxtApp.i18n.global.locale.value = storeLocale as any;
    }
  }
});
